/**
 * 缓存说明:用户信息缓存
 */
import vm from '@/cache/storeTools.js'
import userApi from '@/components/api/userApi.js'
import deviceStore from '@/cache/deviceStore.js'

var basestate = {
	nowUserCode: "", //当前用户登录名
	nowUserInfo: {
		//当前用户信息
	},
	unitIdToUserList:{
		//某单位下的userList
	},
	unitIdToInfo:{
		//单位Id对应单位信息
	},
	userTree:undefined,
	nowCompanyId:"",//当前单位id
}

var store = new vm.Vuex.Store({
	state: copy(basestate),
	getters: {
		//获取当前用户所有可查看的角色列表
		getUserTree(state,getters){
			if(isempty(state.userTree)){
				store.commit('getUserTree')
				return
			}
			return state.userTree
		},
		getUnitUserTree(state,getters){
			//获取单位-用户结构二级树
			if (getters.getUserTree == undefined) {
				return []
			}
			var list = []
			var obj = copy(state.unitIdToInfo)
			eachObject(state.unitIdToUserList,(userList,key)=>{
				var info = obj[key]
				info.next = userList
				list.push(info)
			})
			return list
		}
	},
	mutations: {
		clear() {
			//清理缓存
			store.replaceState(copy(basestate))
		},
		setNowUserCode(state, userCode) {
			//这里是登录后会调用一次的地方，在这里可以做各种初始化数据
			state.nowUserCode = userCode
			//查询当前用户的信息
			userApi.findUserInfoByUserCode(userCode,respon=>{
				state.nowUserInfo = respon
			})
			//刷新可查看设备树
			deviceStore.commit('getReadDeviceTree')
		},
		getUserTree(state){
			function setInfo(item){
				if (item.type=="UsePowerUnit") {
					var list = []
					for (var i = 0, len = item.next.length; i < len; i++){
						var nItem = item.next[i]
						if (nItem.type == 'PcmUser') {
							nItem.name = nItem.username
							list.push(nItem)
						}else{
							setInfo(nItem)
						}
					}
					vm.Vue.set(state.unitIdToUserList,item.id,list)
					vm.Vue.set(state.unitIdToInfo,item.id,item)
				}
			}
			userApi.getUserTree(res=>{
				setInfo(res)
				vm.Vue.set(state, 'userTree', res)
			})
		},
		//当前的单位id
		setCompanyId(state,id){
			state.nowCompanyId = id
		}
	}
});

//对外提供
export default store

/**
 * 需要分页的内容,以数组存储全部,取的时候进行分页,
 * 刷新时获取指定页数据,然后合并,重复的数据以新的为准,
 * 可能会导致缺失遗漏,但是有清理缓存就可以了
 */